export const isPersonInn = (value: string) => {
  if (!/^\d{12}$/.test(value)) {
    return false;
  }
  const control = (weights: number[]) =>
    (weights.reduce((sum, weight, index) => sum + Number(value[index]) * weight, 0) % 11) % 10;
  return (
    control([7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(value[10]) &&
    control([3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(value[11])
  );
};

export const isSnils = (value: string) => {
  const digits = value.replace(/[\s-]/g, '');
  if (!/^\d{11}$/.test(digits)) {
    return false;
  }
  let total = [...digits.slice(0, 9)].reduce((sum, digit, index) => sum + Number(digit) * (9 - index), 0);
  if (total > 101) {
    total %= 101;
  }
  return (total === 100 || total === 101 ? 0 : total) === Number(digits.slice(9));
};

export const formatSnils = (value: string) => {
  const digits = value.replace(/[\s-]/g, '');
  if (!/^\d{0,11}$/.test(digits)) {
    return value;
  }
  return (
    [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)].filter(Boolean).join('-') +
    (digits.length > 9 ? ` ${digits.slice(9)}` : '')
  );
};
